export const ApplianceDetailsSkeleton = () => (
  <div className="flex-1">
    <div className="flex-1 w-full py-space-700 px-space-500">
      <div className="max-w-2xl mx-auto p-space-500 flex flex-col gap-space-500">
        <div className="h-2 flex gap-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <div
              key={`progress-${i}`}
              className="flex-1 rounded-full shimmer overflow-hidden"
            ></div>
          ))}
        </div>
        <div className="flex flex-col gap-1">
          <div className="h-5.5 shimmer" />
          <div className="h-5.5 w-3/4 shimmer" />
        </div>
        <div className="h-5 shimmer w-1/2" />
        <div className="auto-rows-[120px] grid gap-space-500 grid-cols-2 md:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={`grid-${i}`} className="rounded-radius-200 shimmer" />
          ))}
        </div>
        <div></div>
      </div>
    </div>
  </div>
);
